import { mediaUrls } from 'globalconfig/constants/mediaUrls';

const leftMenu = [
  {
    icon: mediaUrls.feedback,
    label: 'leftMenu.feedback',
    path: '/feedback'
  }
];
export default leftMenu;
